import mustache from 'mustache';
import { newReply_dispTemplate, reply_dispTemplate, reviewImg, review_dispTemplate, uploadIconElement } from './mustache_templates';
import { get_camp_reviews, send_campReviewReply, send_campReview_req, send_review_edit } from './socialMedia_api';
import { RVtrippy_campReview, RVtrippy_campReviewResponse, RVtrippy_reviewReply, campReview_orderBy, negative_review_icon_class, neutral_review_icon_class, postive_review_icon_class, reviewReplyData } from './type_defs';
import { uploadReviewImg } from './upload-image';

let currDisplayed_reviews: Array<RVtrippy_campReview> | null = null;
$(document).on("click",".review-reply-but", function(event: JQuery.ClickEvent<any, any, any, any>){
	if(!$(event.target).hasClass("review-reply-but")){
		event.target = $(event.target).parent();
	}
	$(event.target).addClass("d-none");
	let $reviewID:string = $(event.target).parent().attr("id");
	if($(`#${$reviewID}.submitReviewReply`).length == 0){
		newReviewReply(event);
	}
});

$(document).on("click", "[replyButtonClose]", function(){
	let replyToID = $(this).attr("replyToID");
	$(`#${replyToID}.submitReviewReply`).remove();
	$(`#reviewReply_${replyToID}.agButtonReply`).removeClass("d-none");
});

//dependency of mergeSort_reviews
function merge_reviews(left:Array<RVtrippy_campReview>,right:Array<RVtrippy_campReview>, orderBy:campReview_orderBy): Array<RVtrippy_campReview> {
	let arr:Array<RVtrippy_campReview> = [];
	while (left.length && right.length) {
		switch(orderBy) {
			case campReview_orderBy.RatingHigh:
				if (left[0].rating > right[0].rating) {
					arr.push(left.shift());
				} else {
					arr.push(right.shift());
				}
				break;
			case campReview_orderBy.RatingLow:
				if (left[0].rating < right[0].rating) {
					arr.push(left.shift());
				} else {
					arr.push(right.shift());
				}
				break;
			case campReview_orderBy.Newest:
				if (left[0].dateDiff < right[0].dateDiff) {
					arr.push(left.shift());
				} else {
					arr.push(right.shift());
				}
				break;
			case campReview_orderBy.Oldest:
				if (left[0].dateDiff > right[0].dateDiff) {
					arr.push(left.shift());
				} else {
					arr.push(right.shift());
				}
				break;
			default:
				break;
		};
	};
	return [ ...arr, ...left, ...right];
};


/*
 * sorts currently displayed reviews by input orderBy (see util/type_defs for potential orderBy values)
 */
function mergeSort_reviews(reviews: Array<RVtrippy_campReview>, orderBy:campReview_orderBy): Array<RVtrippy_campReview> {
	const midPt:number = reviews.length / 2;
	if (reviews.length < 2) return reviews;
	const left:Array<RVtrippy_campReview> = reviews.splice(0,midPt) as Array<RVtrippy_campReview>;
	return merge_reviews(mergeSort_reviews(left,orderBy), mergeSort_reviews(reviews,orderBy),orderBy);
};

function sendReviewReply(event: JQuery.SubmitEvent) {
	event.preventDefault();
	let $replyEl:HTMLElement = event.target;
	let replyText:string = $($replyEl).find("textarea").val().toString();
	let replyTo_reviewID:string = $($replyEl).attr("id")
	let $parentReview: JQuery<HTMLElement> = $(event.target).parent();
	let $cID_div:JQuery<HTMLElement> = $($parentReview).find(".cID");
	let cID:number = parseInt($($cID_div).attr("id"));
	if (cID===null || Number.isNaN(cID)) return;
	let reviewReplyData:reviewReplyData = {
		text:replyText,
		replyingToID:replyTo_reviewID,
		campID:cID
	};

	send_campReviewReply(reviewReplyData).then(response => {
		let current_datetime:Date = new Date();
			let review_datetime:Date = new Date((response.date as {$date:string}).$date);
			response.date = review_datetime;/* reformat date as JS Date object */
			response.dateDiff = (current_datetime.getTime() - review_datetime.getTime()) / 1000;/* divided by 1000 to convert ms to s */
			response.timeDiffMsg = get_timeDiffStr(review_datetime);
			$($($replyEl).parent()).append(mustache.render(reply_dispTemplate,response));
			$($replyEl).remove();
	}).catch(e => {
		console.error(e);
		$("#campExpandedModal").modal("hide");
		$("#signupModal").modal("show");
	})
};

function newReviewReply(event: JQuery.ClickEvent) {
	if(!$(event.target).hasClass("review-reply-but")){
		event.target = $(event.target).parent();
	}
	let $review:JQuery<HTMLElement> = $(event.target).parent();
	let $replyInput:JQuery<HTMLElement> = $(mustache.render(newReply_dispTemplate,{replyTo_reviewID: $($review).attr("id"),replyTo_dispName: $($($review).find(".dispName")).html()}));
	$replyInput.insertAfter(event.target);
	$(".submitReviewReply").on("submit",(event: JQuery.SubmitEvent<any, any, any, any>) => sendReviewReply(event))
};

//iterates through reviews recursively appending replies underneath
function recursive_reviewReplyDisp(reviewEl:JQuery<HTMLElement>,reviewData:RVtrippy_campReview | RVtrippy_reviewReply) {
	let j:number;
	let newEl:JQuery<HTMLElement>;
	if (reviewData.replies) {
		for (j=0; j<reviewData.replies.length; j++) {
			reviewData.replies[j].timeDiffMsg = get_timeDiffStr(new Date((reviewData.replies[j].date as {"$date":string}).$date));
			newEl = $(mustache.render(reply_dispTemplate,reviewData.replies[j]));
			recursive_reviewReplyDisp(newEl,reviewData.replies[j]);
			reviewEl.append(newEl);
		};
	};
};

function initReviewEditButtons() {
	$(".editReview").on("click", function(this: any) {
		let reviewText:string = $(this).parentsUntil("#reviewAppend").find("#review_text").html();
		//let reviewRating:number = $(this).parentsUntil("#reviewAppend").find(".ai-star-filled").length;
		let reviewRating:number;
		if ($(this).closest("[reviewWrap]").find(".star-rating > i").hasClass(negative_review_icon_class)) {
			reviewRating = -1;
		} else if ($(this).closest("[reviewWrap]").find(".star-rating > i").hasClass(neutral_review_icon_class)) {
			reviewRating = 0;
		} else if ($(this).closest("[reviewWrap]").find(".star-rating > i").hasClass(postive_review_icon_class)) {
			reviewRating = 1;
		};
		let $newReviewForm:JQuery<HTMLElement> = $("#submitCampReview").clone();
		$newReviewForm.attr("id","submitReviewEdit");
		$newReviewForm.find("#review-text").html(reviewText);
		//$newReviewForm.find("#review-rating").find(`option[value="${reviewRating}"]`).prop("selected",true);
		$newReviewForm.find(`input[name="rating"][value="${reviewRating}"]`).prop("checked",true);

		$(this).parentsUntil("#reviewAppend").find(".camp-review").hide();
		$(this).parentsUntil("#reviewAppend").find(".review-edit-wrapper").append($newReviewForm);
		$(this).parentsUntil("#reviewAppend").find(".review-edit-wrapper").show();

		$("#submitReviewEdit").on("submit",function(this: any,event: { preventDefault: () => void; }) {
			event.preventDefault();
			let rating:number = parseInt($(this).closest("[reviewWrap]").find("input[name='rating']:checked").val() as string);
			// let rating:number = $("input[name='rating']:checked").val() as number//parseFloat($(this).find("#review-rating").find(":selected").val().toString());
			let text:string = $(this).find("#review-text").html();
			let reviewID:string = $(this).parentsUntil("#reviewAppend").find(".camp-review").attr("id");

			send_review_edit(reviewID,rating,text).then(response => {
				let j:number;
				let current_datetime:Date = new Date();
				let review_datetime:Date = new Date((response.date as {"$date":string}).$date);
				response.date = review_datetime;/* reformat date as JS Date object */
				response.dateDiff = (current_datetime.getTime() - review_datetime.getTime()) / 1000;/* divided by 1000 to convert ms to s */
				response.timeDiffMsg = get_timeDiffStr(review_datetime);
				switch(response.stars) {
					case -1:
						response.stars_html = `<i class="${negative_review_icon_class}"></i>`;
						break;
					case 0:
						response.stars_html = `<i class="${neutral_review_icon_class}"></i>`;
						break;
					case 1:
						response.stars_html = `<i class="${postive_review_icon_class}"></i>`;
						break;
					default:
						response.stars_html = "";
						break;
				};

				$(`#${reviewID}`).html(mustache.render(review_dispTemplate,response));
				$(`#${reviewID}`).show();
				$("#submitReviewEdit").remove();
				$(".review-edit-wrapper").hide();
			}).catch(e => {
				$("#campExpandedModal").modal("hide");
				const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
				$("#errorModal").modal("show");
			})
		});
	});
};

/*
 * clears any currently displayed reviews
 * initializes listeners for editing / adding images to user's reviews
 * displays reviews in currDisplayed_reviews arr
 * initializes listeners for new review (adding image & text formatting option buttons)
 */
function update_reviewDisp() {
  let i:number;
  $("#reviewAppend").html("");
  for (i = 0; i < currDisplayed_reviews.length; i++) {
    let review:JQuery<HTMLElement>= $(mustache.render(review_dispTemplate, currDisplayed_reviews[i]));
	if (currDisplayed_reviews[i].imageKeys != undefined) {
		for(let j:number=0; j < currDisplayed_reviews[i].imageKeys.length; j++) {
			review.find(".review-img-wrap").append(mustache.render(reviewImg,{img_src:`https://images2-fpascwfudrbufxev.z01.azurefd.net/${currDisplayed_reviews[i].imageKeys[j]}`}))
		};
	};
	if (currDisplayed_reviews[i].curUserReview) {
		let $i:JQuery<HTMLElement> = $("<i>");
		$i.addClass("ai-edit editReview agIconHorange reviewButton");
		review.find(".editReviewWrap").append($i);
		let $imgUploadIcon = $(mustache.render(uploadIconElement,currDisplayed_reviews[i]));
		review.find(".addReviewImgWrap").append($imgUploadIcon);
		$imgUploadIcon.find(".ai-upload").on("click",()=>{$($imgUploadIcon).find("input").trigger("click")});
		$imgUploadIcon.find("input").on("change",(event: { target: { files: FileList; }; })=>{
		let selectedFiles:FileList = event.target.files;


		let reviewID:string = $imgUploadIcon.parentsUntil(".camp-review").parent().attr("id");

		for (let j:number=0; j < selectedFiles.length; j++) {
			let fileSize_MB = selectedFiles[j].size / (1024 * 1024);
			let fileName:string = selectedFiles[j].name;
			if (fileSize_MB > 30) {
				$("#existingReview-addImg-err").append($(`<h6 class="text-danger">File ${fileName} too large (>3MB)</h6>`))
			} else {
				uploadReviewImg(selectedFiles[j],reviewID).then(imagePath => {
					$imgUploadIcon.parentsUntil(".camp-review").parent().find(".review-img-wrap").append(mustache.render(reviewImg,{img_src:`https://images2-fpascwfudrbufxev.z01.azurefd.net/${imagePath}`}))
				}).catch(e => {
					const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
					$("#errorModal").modal("show");
				});
			};
		};
		});
	};
    recursive_reviewReplyDisp(review,currDisplayed_reviews[i]);
    $("#reviewAppend").append(review);
  };
  initReviewEditButtons();
};

export function order_campReviews(orderBy:campReview_orderBy) {
	currDisplayed_reviews = mergeSort_reviews(currDisplayed_reviews, orderBy);
	update_reviewDisp();
};

/*
 * takes input Date & creates string describing how long ago date was based on current dateTime
 */
function get_timeDiffStr(review_date:Date):string {
	let message:string;
	let cur_date:Date = new Date();
	let diff:number = Math.floor((cur_date.getTime() - review_date.getTime())/ 1000);
	let min:number = 60;
	let hr:number = min * 60;
	let day:number = hr * 24;
	let month:number = day * 31;
	let yr:number = month * 12;
	let years:number = Math.floor(diff/yr);
	let months:number = Math.floor(years? (diff % (years*yr)) / month : diff/month);
	let days:number = Math.floor((years*yr + months*month)? (diff % (years*yr + months*month))/day : diff/day);
	let hrs:number = Math.floor((years*yr + months*month + days*day)? (diff % (years*yr + months*month + days*day)) / hr : diff/hr);
	let mins:number = Math.floor((years*yr + months*month + days*day + hrs*hr)? (diff % (years*yr + months*month + days*day + hrs*hr)) / min : diff/min);
	let secs:number = Math.floor((years*yr + months*month + days*day + hrs*hr + mins*min)? diff % (years*yr + months*month + days*day + hrs*hr + mins*min) : diff);
	if (years) {
		message = years.toString() + (years>1?" years ":" year ");
		message += months>0? "," + months.toString() + (months>1?" months ago":" month ago") : "ago";
	} else if (months) {
		message = months.toString() + (months>1?" months ":" month ");
		message += days>0? "," + days.toString() + (days>1?" days ago":" day ago") : "ago";
	} else if (days) {
		message = days.toString() + (days>1?" days ":" day ");
		message += hrs>0? "," + hrs.toString() + (hrs>1?" hours ago":" hour ago") : "ago";
	} else if (hrs) {
		message = hrs.toString() + (hrs>1?" hours ":" hour ");
		message += mins>0? "," + mins.toString() + (mins>1?" mins ago":" min ago") : "ago";
	} else if (mins) {
		message = mins.toString() + (mins>1?" mins ":" min ");
		message += secs>0? "," + secs.toString() + (secs>1?" seconds ago":" second ago"): "ago";
	} else if (secs) {
		message = secs.toString() + (secs>1?" seconds ":" second ") +"ago";
	} else if (secs == 0 && mins == 0 && hrs == 0 && days == 0 && months == 0 && years == 0) {
		message = "1 second ago";
	};
	return message;
};

export function addReviewDisplay_expandedCard(reviews: RVtrippy_campReview[]){
	let i:number;
	let j:number;
	let review_aggr_counts: number[] = [0,0,0,0,0];
	let modal: JQuery<HTMLElement> = $("#campExpandedModal");
	let avg_review:number;

	for (i = 0; i < reviews.length; i++) {
		let current_datetime:Date = new Date();
		let review_datetime:Date = new Date((reviews[i].date as {"$date":string}).$date);
		reviews[i].date = review_datetime;/* reformat date as JS Date object */

		reviews[i].dateDiff = (current_datetime.getTime() - review_datetime.getTime()) / 1000;/* divided by 1000 to convert ms to s */

		reviews[i].timeDiffMsg = get_timeDiffStr(review_datetime);

		review_aggr_counts[reviews[i].rating - 1]++;
		switch(reviews[i].rating) {
			case -1:
			reviews[i].stars_html = `<i class="${negative_review_icon_class}"></i>`;
			break;
		case 0:
			reviews[i].stars_html = `<i class="${neutral_review_icon_class}"></i>`;
			break;
		case 1:
			reviews[i].stars_html = `<i class="${postive_review_icon_class}"></i>`;
			break;
		default:
			reviews[i].stars_html = "";
			break;
		};

		avg_review += reviews[i].rating;
		// reviews[i].stars_html = `<div class="d-flex flex-row"><p>${reviews[i].rating}/10</p><i class=\"sr-star ai-star-filled active\"></i></div>`;
		// for(j = 0; j < 10; j++){
		// 	if(j < reviews[i].rating){
		// 		reviews[i].stars_html += "<i class=\"sr-star ai-star-filled active\"></i>";
		// 	}else{
		// 		reviews[i].stars_html += "<i class=\"sr-star ai-star\"></i>";
		// 	};
		// };
	};
	currDisplayed_reviews = mergeSort_reviews(reviews, campReview_orderBy.Newest);
	update_reviewDisp();

	avg_review /= currDisplayed_reviews.length;
	modal.find(".expCampCard-rating").html(avg_review.toFixed(2));
	let rating_rounded: number = parseInt(avg_review.toFixed());
	// let starRating_html:string = "";
	// for(j = 0; j < rating_rounded; j++) {
	// 	starRating_html += "<i class=\"sr-star ai-star-filled active\"></i>";
	// };
	// for(j = 0; j < 10 - rating_rounded; j++) {
	// 	starRating_html += "<i class=\"sr-star ai-star\"></i>";
	// };
	let starRating_html:string = `<div class="d-flex flex-row"><p>${rating_rounded}/10</p><i class=\"sr-star ai-star-filled active\"></i></div>`;
};

//TODO : Make mustache template of reviews, display the html using JS after you pull the results.
export function disp_campReviews(camp_id: number) {
	let data: {data:{reviews:Array<RVtrippy_campReview>},campID:number} = {data:{reviews:null},campID:null};
	data.campID = camp_id;
	$(".camp-review").remove();
	get_camp_reviews(camp_id).then((reviews) => {
		addReviewDisplay_expandedCard(reviews);
	}).catch(e => {
		const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
		$("#errorModal").modal("show");
	});
};

function newReview_uploadImgs(reviewID:string, files:File[]) {
	for (let i:number=0; i < files.length; i++) {
		uploadReviewImg(files[i],reviewID).then(imagePath => {
			$(`#${reviewID}`).find(".review-img-wrap").append(mustache.render(reviewImg,{img_src:`https://images2-fpascwfudrbufxev.z01.azurefd.net/${imagePath}`}));
		}).catch(e => {
			const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
			$("#errorModal").modal("show");
		});
	};
};

function handleServerRepsonse_displayReview(data:RVtrippy_campReviewResponse, review_images:File[]) {
	let j: number;
	let current_datetime:Date = new Date();
	let review_datetime:Date = new Date((data.date as {$date:string}).$date);
	data.date = review_datetime;/* reformat date as JS Date object */
	data.dateDiff = (current_datetime.getTime() - review_datetime.getTime()) / 1000;/* divided by 1000 to convert ms to s */
	data.timeDiffMsg = get_timeDiffStr(review_datetime);
	// data.stars_html = "";
	// for(j = 0; j < 10; j++) {
	// 	if (j < data.stars) data.stars_html += "<i class=\"sr-star ai-star-filled active\"></i>";
	// 	else data.stars_html += "<i class=\"sr-star ai-star\"></i>";
	// }
	switch(data.stars) {
		case -1:
			data.stars_html = `<i class="${negative_review_icon_class}"></i>`;
			break;
		case 0:
			data.stars_html = `<i class="${neutral_review_icon_class}"></i>`;
			break;
		case 1:
			data.stars_html = `<i class="${postive_review_icon_class}"></i>`;
			break;
		default:
			data.stars_html = "";
			break;
	};
	let review: string = mustache.render(review_dispTemplate, data);
	$("#reviewAppend").prepend(review);
	$("#review-text").val("");
	$("#review-text").html("");
	$("#new-review-image-wrap").html("");
	$("#review-rating").find(":selected").prop("selected",false);
	$("#submitCampReview").removeClass("was-validated");
	newReview_uploadImgs(data._id.$oid,review_images);
};

export function send_campReview(review_text: string, review_rating: number, review_campID: number, review_images:File[]) {
	send_campReview_req(review_campID,review_rating,review_text).then(result => handleServerRepsonse_displayReview(result,review_images)).catch(e => {
	if($("#campExpandedModal").length > 0) $("#campExpandedModal").modal("hide");
	const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
	$("#errorModal").modal("show");
	});
};